module.exports = __webpack_public_path__ + "img/ic-alert.bfc28156.svg";